import script from "./vacancy-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./vacancy-list.vue?vue&type=script&setup=true&lang=ts"

import "./vacancy-list.vue?vue&type=style&index=0&id=567d03ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-567d03ae"]])

export default __exports__